import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ShipmentWaybillTrackingMapService } from './shipment-waybill-tracking-map.service';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants/error';
import { WaybillMapStop } from '../../../../../common/models/map-tracking-points.model';
import {
  ShipmentWaybillTrackingMapInitialState,
  ShipmentWaybillTrackingMapLoad,
} from './shipment-waybill-tracking-map.actions';
import { WaybillTrackingMap } from '../../../../models/waybill-tracking-map.model';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { ShipmentWaybillMapData } from '../../models';

export interface ShipmentWaybillTrackingMapInitialStateModel {
  mapData: ShipmentWaybillMapData | null;
  loaded: boolean;
}

const initialState: ShipmentWaybillTrackingMapInitialStateModel = {
  mapData: null,
  loaded: false,
};

@State<ShipmentWaybillTrackingMapInitialStateModel>({
  name: 'shipmentWaybillTrackingMapData',
  defaults: initialState,
})
@Injectable()
export class ShipmentWaybillTrackingMapState {
  constructor(
    private shipmentWaybillTrackingMapService: ShipmentWaybillTrackingMapService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getState(state: ShipmentWaybillTrackingMapInitialStateModel): ShipmentWaybillTrackingMapInitialStateModel {
    return state;
  }
  @Selector()
  static getLoaded(state: ShipmentWaybillTrackingMapInitialStateModel): boolean {
    return state.loaded;
  }
  @Selector()
  static getMapData(state: ShipmentWaybillTrackingMapInitialStateModel): ShipmentWaybillMapData {
    return state.mapData;
  }

  @Action(ShipmentWaybillTrackingMapLoad)
  getWaybillTrackingMapData(
    ctx: StateContext<ShipmentWaybillTrackingMapInitialStateModel>,
    { payload }: ShipmentWaybillTrackingMapLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentWaybillTrackingMapService.getShipmentWaybillTrackingMapData(payload).pipe(
      map((data: WaybillTrackingMap) => {
        const gpsPoints = data.mapData.gpsPoints.map((point: WaybillMapStop, index: number) => {
          point.sortIndex = `${index}`;
          return point;
        });
        ctx.patchState({
          mapData: { gpsPoints, transportMode: data.transportMode },
          loaded: true,
        });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentWaybillTrackingMapInitialState)
  setInitialState(ctx: StateContext<ShipmentWaybillTrackingMapInitialStateModel>): void {
    ctx.setState(initialState);
  }
}
